"use strict";

var React = require('react');
var ReactForms = require('react-forms');
var ScalarNode = ReactForms.schema.ScalarNode;
var createNode = ReactForms.schema.createNode;
var TimeSelect = require('ofs/forms/inputs/time-select');

var Field = require('ofs/forms/components/better-field');

function TimeScalar(props) {
  props.input = props.input || <TimeSelect />;
  props.type = 'string';
  props.component = Field;
  return createNode(ScalarNode, props);
}

module.exports = TimeScalar;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/forms/scalars/TimeScalar.jsx
 **/